import { useContextState } from "../../../../../hooks/theme"

const useStyles = () => {
    const { colors } = useContextState()

    return {
        /* scheduleTitle: {
            fontSize: '14px',
            fontWeight: '500',
            color: colors.color16,
        }, */
        /* subTitle: {
            fontSize: '16px',
            fontWeight: '600',
            color: colors.color26,
            margin: '10px 0',
        }, */
        flex: {
            display: 'flex',
            flexDirection: 'column',
            gap: 1
        },
        flexGp2: {
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
            height:'93%',
            overflow:'auto',
            scrollbarWidth: 'none'
        },
        /* containerAcordion: {
            position:'relative',
            padding:'1px'
        }, */
        /* header: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
        }, */
        notifications: {
            paddingBottom:2,
            borderBottom:`1px solid ${colors.color13}`
        },
        /* icon: {
            color: colors.color13,
            display: 'flex',
            alignItems: 'center',
        }, */
        containerIcon: {
            color: colors.color13,
            display: 'flex',
            gap: '4px'
        },
        containerChild: {
            /* display: 'flex',
            flexDirection: 'column',
            gap: 1 */
            '& .title_text':{
                width:'100%',
                marginBottom:1,
                textAlign:'start !important',
                color:colors.color13
                //display:'box'
            }

        },
        circle: {
            width: '5px',
            height: '5px',
            backgroundColor: colors.color13,
            borderRadius: '50%',
        },
        textList: {
            //display: 'flex',
            // alignItems: 'start',
            // gap: 1,
            //mt: 0.5,
            textAlign: 'start !important',
            //width: '100%',
            color:colors.color13
        },
        containerCircle: {
            minWidth: '15px',
            paddingTop: 1.2
        },
        aceptButton: {
            //fontSize: '12px',
            height: 'fit-content',
            maxWidth: '150px',
            wordBreak: 'break-word',
        },
        cancelButton: {
            padding: '0',
            '&.cancel-drawer': {
                fontSize: '12px',
            },
        },
        containerChildButtons: {
            display: 'flex',
            justifyContent: 'space-between',
            marginTop: 2,
            height:'5%'
        }
    }
}

export { useStyles }
